import React from "react";

const TextInput = ({ label, placeholder, value, onChange, style, className }) => {
    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <input
                type="text"
                className={`form-control${className ? ' ' + className : ''}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={style}
                // nombre de caractères max
                
            />
        </div>
    );
};

export default TextInput;
